import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { fundLevel } from '@/react-query/queries/ic-report/hooks'

const percentageFormatter = numberFormatter({
  suffix: '%',
  transformer: (val) => val * 100,
})

const colDefs = createColDefs([
  {
    field: 'tracking_difference',
    headerName: 'Difference',
  },
  {
    field: 'mtd_fund_value',
    headerName: 'MTD Fund Value',
    valueFormatter: percentageFormatter,
  },
  {
    field: 'mtd_bench_value',
    headerName: 'MTD Bench Value',
    valueFormatter: percentageFormatter,
  },
  {
    field: 'mtd_diff',
    headerName: 'MTD Difference',
    valueFormatter: percentageFormatter,
  },
  {
    field: 'ytd_fund_value',
    headerName: 'YTD Fund Value',
    valueFormatter: percentageFormatter,
  },
  {
    field: 'ytd_bench_value',
    headerName: 'YTD Bench Value',
    valueFormatter: percentageFormatter,
  },
  {
    field: 'ytd_diff',
    headerName: 'YTD Diff',
    valueFormatter: percentageFormatter,
  },
])

export interface TrackingDifferencesTableProps extends ICReportTablePrimitive {}

export const TrackingDifferencesTable: React.FC<TrackingDifferencesTableProps> = ({
  params,
  options,
}) => {
  const query = fundLevel.useTrackingDifferences(params)
  const data = query.data

  return <CustomAgGrid loading={query.isLoading} rowData={data} columnDefs={colDefs} {...options} />
}
